/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2019-11-15 09:29:32
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2020-11-03 15:22:02
 */

import common from '@/common/old/public/common';
import config from '@/config/config';
import {router} from '@/router.js';
const state = {
  isLogin: false,
  routerList: [],
  isGetRouter: false,
  userInfo: null,
  operatorInfo: null,
  openid: null,
  position: null,
  wxRightMap: {},
  group: null, //  是否企业用户
  isCar: false, // 是否要车牌
  isOnline: true, // 网络状态
  isHeader: false,
  header: 0.88, // rem 的高度
  headerHeight: 0, // 计算过后的 header 高度,有可能会添加其它高度
  headerHeightFixed: 0, // 计算过后的 header 高度,计算后就固定了
  appTop: 0, // app 电池栏的高度，在app 里才有
  activityShow: false, // 显示突然得到的优惠券
  couponList: [], // 突然得到的优惠券
};

// 筛选数据、改变状态的方法
const getters = {
  getLogin(state) {
    return state.isLogin;
  }
};
// 同步操作 是变更参数的方法
const mutations = {
  SET_ISLOGIN(state, status) {
    state.isLogin = status;
  },
  SET_USERINFO(state, data) {
    state.userInfo = data;
    // if (data && data.groupUser) {
    //   state.group = data.groupUser;
    // } else {
    //   state.group = null;
    // }
    // state.group = data && data.groupUser || null;
  },
  MERGE_USERINFO(state, data) {
    state.userInfo = Object.assign(state.userInfo, data);
    common.save(config.localKeyLogin.myInfo, state.userInfo);
  },
  SET_OPERATORINFO(state, data) {
    if (data.openCarNumber === 1) {
      state.isCar = true; // 是否要车牌
    }
    if (data.chargEndCountDown) {
      config.orderEndTime = data.chargEndCountDown; // 充电结束后，(默认,后台没设置的时候)几秒跳转
    }
    if (data.smsCountDown) {
      config.messageTime = data.smsCountDown; // 短信时间(默认,后台没设置的时候)
    }
    if (data.openChargeRecharge === 1) {
      config.chargingIsRecharge = true; // 充电中是否可以充值
    } else {
      config.chargingIsRecharge = false;
    }

    state.operatorInfo = data;
  },
  SET_OPENID(state, data) {
    state.openid = data;
  },
  SET_POSITION(state, data) {
    state.position = data;
  },
  setA(state, data) {
    state.openid = data;
  },
  SET_WXRIGHTMAP(state, data) {
    state.wxRightMap = data;
  },

  OUT(state) {
    state.isLogin = false;

    this.commit('SET_USERINFO', null);
    for (let i in config.localKeyLogin) {
      common.remove(config.localKeyLogin[i]);
    }
    router.push('/login');
  },
  SET_ISHEADER(state, data) {
    state.isHeader = data;
  },
  SET_HEADERHEIGHT(state, data) {
    state.headerHeight = data;
  },
  SET_HEADERHEIGHTFIXED(state, data) {
    state.headerHeightFixed = data;
  },
  SET_APPTOP(state, data) {
    state.appTop = data;
  },
  SET_ISONLINE(state, status) {
    state.isOnline = status;
  },
  SET_ACTIVITYSHOW(state, status){
    state.activityShow = status;
  },
  SET_ACTIVITYLIST(state, data){
    state.activityList = data;
  }
};

// 异步操作
const actions = {
  async getActivityCoupon({ commit }) {
    const ret = {};//await getOprInfo({});
    if (ret.status === config.apiStatus) {
      commit("SET_ACTIVITYSHOW", true);
      commit("SET_ACTIVITYLIST", ret.data);
    }
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};